import type { FormConfigType } from '@cloudbeds/payment-tokenization';

export const generateDefaultTokenexFormConfig =
  (): Partial<FormConfigType> => ({
    cardFields: {
      cardholderName: {
        required: true,
      },
      cardNumber: {
        required: true,
      },
      expiry: {
        required: true,
      },
      cvv: {
        required: true,
      },
    },
    contactFields: {
      firstName: {
        required: true,
      },
      lastName: {
        required: true,
      },
    },
    billingFields: {},
  });
